<template>
  <div>
    <v-col cols="12" class="align-center justify-center d-flex login-image">
      <v-row justify="center">
        <v-card
          class="pa-10 pb-8"
          max-width="420"
          :elevation="24"
          v-if="forgot"
        >
          <Logo
            :url="getCouncilImage"
            alt="Logo Benfeitores"
            height="65"
            width="185"
          />
          <h4 class="mt-12">Recuperação de Senha</h4>
          <p class="mt-2">Insira seu E-mail ou CPF abaixo:</p>
          <v-row>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-form v-model="isFormValid">
                    <!-- <v-text-field
                                            v-if="useMask"
                                            v-model="agentCPF"
                                            v-mask="['###.###.###-##']"
                                            label="E-mail ou CPF"
                                            outlined
                                            hide-details
                                            required
                                            :rules="[validateDocumentOrEmail]"
                                            :disabled="loading"
                                        ></v-text-field> -->
                    <!-- v-else -->
                    <v-text-field
                      v-model="agentInformation"
                      label="E-mail ou CPF"
                      outlined
                      hide-details
                      required
                      :rules="[validateDocumentOrEmail]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
            <v-col cols="6">
              <v-btn
                :loading="loading"
                rounded
                depressed
                x-large
                block
                outlined
                color="var(--gray)"
                @click="loginBack()"
                >Voltar</v-btn
              >
            </v-col>

            <v-col cols="6">
              <v-btn
                :loading="loading"
                rounded
                depressed
                x-large
                block
                color="primary"
                @click="recoverPassword()"
                :disabled="!isFormValid"
                >Recuperar</v-btn
              >
            </v-col>
            <v-col cols="12" class="mt-12">
              <p class="mb-0 mt-12 text-center">
                Não possui conta?
                <a class="text-center primary--text">Cadastre-se!</a>
              </p>
            </v-col>
          </v-row>
        </v-card>

        <v-card class="pa-10 pb-8" max-width="420" :elevation="24" v-else>
          <Logo
            :url="getCouncilImage"
            alt="Logo Benfeitores"
            height="65"
            width="185"
          />
          <h4 class="mt-12">Recuperação de Senha</h4>
          <p class="mt-2">
            Foi enviado um e-mail com as orientações necessárias para você
            redefinir sua senha.
          </p>
          <p>
            Caso não tenha recebido o e-mail, verifique sua caixa de SPAM e
            cadastre o dominio
            <span class="text--primary">@cmi.com.br</span> nos seus contatos.
          </p>

          <p class="text--primary mt-8 text-center">
            Quer tentar novamente?
          </p>
          <p class="text-center">
            <!-- <router-link @click="resendRecoverEmail()"
                            >Reenviar e-mail</router-link
                        > -->
            <v-btn
              text
              :loading="loading"
              rounded
              depressed
              x-large
              color="var(--gray)"
              @click="resendRecoverEmail()"
              class="px-12"
              >Reenviar e-mail</v-btn
            >
          </p>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-btn
                :loading="loading"
                rounded
                depressed
                x-large
                outlined
                color="var(--gray)"
                @click="loginBack()"
                class="px-12"
                >Voltar ao Login</v-btn
              >
            </v-col>

            <v-col cols="12" class="mt-3">
              <p class="ma-0 text-center">
                Não possui conta?
                <a class="text-center primary--text">Cadastre-se!</a>
              </p>
            </v-col>
          </v-row>
        </v-card>
      </v-row>
    </v-col>
    <!-- Dialog with sucess message -->
    <template>
      <v-dialog
        v-model="showUserDoesntExistMessageDialog"
        persistent
        max-width="490"
      >
        <v-card>
          <v-card-title>
            <h5 class="pt-5 pb-7">Usuário não existe</h5>
          </v-card-title>
          <v-card-text
            >Não foi possível encontrar um usuário com esse email.</v-card-text
          >
          <v-card-actions class="px-6 py-5">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              depressed
              large
              @click="showUserDoesntExistMessageDialog = false"
              >Ok, entendi!</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <!-- End of Dialog with sucess message -->
  </div>
</template>

<script>
// import Routes from "@/router/names.js";

import { mapGetters } from "vuex";
import Logo from "@/components/Logo";

import AuthService from "@/scripts/services/auth.service";

import CommonHelper from "@/scripts/helpers/common.helper";

export default {
  name: "Forgot",
  inject: ["theme"],
  components: {
    Logo
  },
  data: () => ({
    authService: new AuthService(),
    forgot: true,
    agentInformation: "",
    loading: false,
    isFormValid: false,
    recoverHash: "",
    showUserDoesntExistMessageDialog: false,
    // agentCPF: "",
    // agentEmail: "",
  }),
  computed: {
    ...mapGetters(["getCouncilImage"]),
    useMask() {
      if (
        this.agentInformation &&
        this.agentInformation != "" &&
        this.agentInformation[0] >= "0" &&
        this.agentInformation[0] <= "9"
      ) {
        return true;
      } //return ["###.###.###-##"];
      return false;
    }
  },
  watch: {
    // agentEmail() {
    //     this.agentInformation = this.agentEmail;
    // },
    // agentCPF() {
    //     this.agentInformation = this.agentCPF;
    // },
  },
  methods: {
    loginBack() {
      this.$emit("backToLogin");
    },
    validateDocumentOrEmail() {
      if (
        this.agentInformation &&
        (CommonHelper.validateEmail(this.agentInformation) ||
          CommonHelper.validateCPF(this.agentInformation))
      )
        return true;
      return "Preencha seu E-mail ou CPF.";
    },
    resendRecoverEmail() {
      this.loading = true;
      this.authService
        .resendRecoverPasswordEmail(this.recoverHash)
        .finally(() => (this.loading = false));
    },
    recoverPassword() {
      this.loading = true;
      this.authService
        .recoverPassword(this.agentInformation)
        .then(this.recoverPasswordCallback)
        .catch(this.recoverPasswordCatch);
    },
    recoverPasswordCallback(result) {
      this.loading = false;
      if (result) {
        this.recoverHash = result;
        this.forgot = false;
      } else {
        this.showUserDoesntExistMessageDialog = true;
      }
    },
    recoverPasswordCatch() {
      this.loading = false;
      CommonHelper.swal(
        "Falha",
        "Não foi possível recuperar a sua senha",
        "error"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.copyright {
  font-size: 12px;
  text-align: center;
  color: #6c7293;
  position: absolute;
  bottom: 20px;
}
</style>
